import React from 'react';
import { useThemeClasses } from '../../hooks/useThemeClasses';

const ICONS = {
  success: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  ),
  error: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  ),
  warning: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
  ),
  info: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  )
};

function AlertIcon({ type, modoOscuro }) {
  const bg = {
    success: modoOscuro ? 'bg-green-800/50 text-green-300' : 'bg-green-100 text-green-600',
    error: modoOscuro ? 'bg-red-800/50 text-red-300' : 'bg-red-100 text-red-600',
    warning: modoOscuro ? 'bg-amber-800/50 text-amber-300' : 'bg-amber-100 text-amber-600',
    info: modoOscuro ? 'bg-blue-800/50 text-blue-300' : 'bg-blue-100 text-blue-600'
  };

  return (
    <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${bg[type] || bg.error}`}>
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        {ICONS[type] || ICONS.error}
      </svg>
    </div>
  );
}

export default function FormAlert({
  type = 'error',
  children,
  className = '',
  icon = true,
  action = null
}) {
  const tc = useThemeClasses();
  if (!children) return null;

  const styles = {
    success: tc.alertSuccess,
    error: tc.alertError,
    warning: tc.alertWarning,
    info: tc.alertInfo
  };

  return (
    <div
      role="alert"
      className={`mb-2 p-3 rounded-xl border-l-4 shadow-sm text-sm ${styles[type] || styles.error} ${className}`}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          {icon && <AlertIcon type={type} modoOscuro={tc.modoOscuro} />}
          <span className="font-semibold">{children}</span>
        </div>
        {action}
      </div>
    </div>
  );
}
